import ApprovalStages from "./ApprovalStages";

const CustomComponents = [
    {
        name: "stages",
        component: ApprovalStages
    }
];

export default CustomComponents;
